"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.slashDateOrder = void 0;
exports.slashDateOrder = {
    FR: 'DMY',
    IT: 'DMY',
    US: 'MDY',
};
